// 捨牌落到海底前，暫存核心已發布的下一回合 action。
// 核心狀態機維持同步推進；scene 等海底動畫完成後再放行 UI / AI。

export class CDiscardLandingGate<TAction, TDraw = never> {
  private waiting = false;
  private pendingAction: TAction | null = null;
  private pendingDraw: TDraw | null = null;

  begin(): void {
    this.waiting = true;
    this.pendingAction = null;
    this.pendingDraw = null;
  }

  hold(action: TAction): boolean {
    if (!this.waiting) return false;
    this.pendingAction = action;
    return true;
  }

  holdDraw(draw: TDraw): boolean {
    if (!this.waiting) return false;
    this.pendingDraw = draw;
    return true;
  }

  takeDraw(): TDraw | null {
    const draw = this.pendingDraw;
    this.pendingDraw = null;
    return draw;
  }

  complete(): TAction | null {
    const action = this.pendingAction;
    this.waiting = false;
    this.pendingAction = null;
    return action;
  }

  cancel(): void {
    this.waiting = false;
    this.pendingAction = null;
    this.pendingDraw = null;
  }

  isWaiting(): boolean {
    return this.waiting;
  }
}
